export enum CounterpartyExecutionTaskCode {
  Card = 'card',
  Addresses = 'addresses',
  Contacts = 'contacts',
  BankDetails = 'bankDetails',
  Comment = 'comment',
}
